import './research-page.css'

const studies = [
  {
    label: 'Estudio 01',
    title: 'Alteraciones del ciclo menstrual y confinamiento',
    paragraphs: [
      'El confinamiento total que vivimos todas las personas durante el año 2020 lo hemos vivido de infinidad de maneras distintas. Pero hay peculiaridades concretas y comunes asociadas al proceso de la menstruación, que nos llevaron a sacar algunas conclusiones importantes.',
      'La salud menstrual es un reto en los diversos contextos de crisis sanitaria, económica, climática y comunitaria, y por ende, es necesario estudiarla ante situaciones excepcionales de falta de condiciones para el buen funcionamiento de las hormonas sexuales femeninas.'
    ],
    cta: 'Leer Artículo',
    href: 'https://matriz.net/mys4849/img/mys49-especial-covid.pdf',
    note: 'Resultados publicados en MyS, página 13'
  },
  {
    label: 'Estudio 02',
    title: 'Atención sanitaria en menopausia y climaterio',
    paragraphs: [
      'Esta Asociación ha respaldado un estudio sobre cómo perciben las mujeres en el Estado español, la atención sanitaria en la etapa de la menopausia y climaterio. Nace de la iniciativa de Carolina Ackermann, cofundadora de la Asociación de cultura menstrual, La Vida en Rojo.',
      'Colabora Marisela Romero psicóloga y promotora de Igualdad de Género, cofundadora de la Asociación FemIgual, impulsora del objetivo final de este estudio: elaborar un modelo de carta que ampare y empodere a las mujeres a la hora de solicitar una correcta atención sanitaria.'
    ],
    cta: 'Leer Artículo',
    href: 'https://www.matriz.net/numero-50/atencion-sanitaria-en-menopausia-climaterio-recogida-de-informacion-testimonios-el-estado-espanol/',
    note: 'Investigación situada y testimonios'
  }
]

const collaborations = [
  {
    label: 'Colaboración 01',
    title: 'Estudio sobre la pobreza e higiene menstrual en la CAE',
    editedBy: 'Emakunde – Instituto Vasco de la Mujer',
    team: 'EDE Fundazioa',
    date: 'Diciembre, 2021',
    cta: 'Acceder al estudio',
    href: 'https://drive.google.com/file/d/1xLTv-R2FvLel3v2eod84JiaLroAhMQtI/view?usp=sharing'
  },
  {
    label: 'Colaboración 02',
    title: 'Informe Equidad y salud menstrual en España',
    editedBy: 'Institut de Recerca en Atenció Primària Jordi Gol i Gurina (IDIAPJGol)',
    team: 'Laura Medina Perucha (coordinadora) y equipo del IDIAPJGol, con la colaboración de Carme Valls-Llobet (CAPS) y Diana Pinzón (SomiArte Taller), entre otras',
    date: 'Mayo, 2023',
    cta: 'Acceder al estudio',
    href: 'https://www.researchgate.net/publication/370819094_Equidad_y_salud_menstrual_en_Espana'
  },
  {
    label: 'Colaboración 03',
    title: 'La perimenopausia afecta al bienestar emocional y social, según un estudio',
    editedBy: 'Institut de Recerca en Atenció Primària Jordi Gol i Gurina (IDIAPJGol)',
    team: 'Investigadoras del IDIAPJGol',
    date: 'Julio, 2026',
    cta: 'Acceder al estudio',
    href: 'https://idiapjgol.org/es/noticia/la-perimenopausia-afecta-al-bienestar-emocional-y-social-segun-un-estudio/'
  }
]

const ResearchPage = () => {
  return (
    <section className='research-page'>
      <a className='research-page__back-link' href='/asociacion'>
        <span aria-hidden='true'>←</span>
        Volver
      </a>

      <header className='research-page__hero'>
        <div>
          <span className='research-page__eyebrow'>Eje de intervención</span>
          <h1>Investigación</h1>
          <p>
            Impulsamos y participamos en estudios propios y colaboraciones. Mantenemos una revisión crítica y continua del conocimiento con perspectiva feminista para fundamentar nuestra acción.
          </p>
        </div>


      </header>

      <section className='research-page__studies' aria-label='Estudios de investigación'>
        {studies.map((study, index) => (
          <article className='research-page__study' key={study.title}>
            <div className='research-page__study-marker'>
              <span>{study.label}</span>
              <strong>{String(index + 1).padStart(2, '0')}</strong>
            </div>

            <div className='research-page__study-content'>
              <p className='research-page__study-note'>{study.note}</p>
              <h2>{study.title}</h2>
              <div className='research-page__study-copy'>
                {study.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
              <a className='main__button main__button--alt' href={study.href} target='_blank' rel='noreferrer'>
                {study.cta}
              </a>
            </div>
          </article>
        ))}
      </section>

      <section className='research-page__collaborations' aria-label='Colaboraciones en investigación'>
        <div className='research-page__collaborations-intro'>
          <h2>Colaboraciones</h2>
          <p>
            Desde La Vida en Rojo colaboramos con entidades e investigadoras afines en estudios e informes que amplían el conocimiento sobre educación, salud, equidad menstrual y peri/menopausia.
          </p>
          <p>
            Compartimos algunas de estas colaboraciones, y seguimos abiertas a sumar esfuerzos con quienes trabajan con perspectiva feminista, interseccional, antirracista, antihigienista, anticapacitista y anticapitalista.
          </p>
        </div>

        <div className='research-page__collaborations-list'>
          {collaborations.map((collaboration, index) => (
            <article className='research-page__collaboration-item' key={collaboration.title}>
              <div className='research-page__collaboration-marker'>
                <span>{collaboration.label}</span>
                <strong>{String(index + 1).padStart(2, '0')}</strong>
              </div>

              <div className='research-page__collaboration-content'>
                <h3>{collaboration.title}</h3>
                <div className='research-page__collaboration-details'>
                  <p>
                    <strong>Edita:</strong> {collaboration.editedBy}
                  </p>
                  <p>
                    <strong>Equipo de trabajo:</strong> {collaboration.team}
                  </p>
                  <p>
                    <strong>Fecha:</strong> {collaboration.date}
                  </p>
                </div>
                <a className='main__button main__button--alt' href={collaboration.href} target='_blank' rel='noreferrer'>
                  {collaboration.cta}
                </a>
              </div>
            </article>
          ))}
        </div>
      </section>
    </section>
  )
}

export default ResearchPage
